export const data = [ 
        'Cómics',
        'Libros Autobiográficos',
        'Libros científicos',
        'Libros de Autoayuda',
        'Libros de Aventuras',
        'Libros de ciencia ficción',
        'Libros de Cuentos',
        'Libros de deporte',
        'Libros de Humor',
        'Libros de la Segunda Guerra Mundial',
        'Libros de marketing',
        'Libros de salud',
        'Libros de suspense',
        'Libros de videojuegos',   
        'Libros sociedad',
        'Microrrelatos',
        'Novela de culto',
        'Novela de no ficción',
        'Novela Histórica',
        'Novela negra',
        'Novela',
        'Novela Romántica',        
]